// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-plugin-docs h2{margin-bottom:15px;font-size:22px;font-weight:700}.checkbox-plugin-docs h3{margin-top:50px;margin-bottom:10px;font-size:18px;font-weight:600}.checkbox-plugin-docs h4{margin-top:30px;margin-bottom:10px;font-size:16px;font-weight:600}.checkbox-plugin-docs p{color:#7a7f89;font-size:15px}.checkbox-plugin-docs mark{background:none;color:#2680eb}.checkbox-plugin-docs .section{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
